import UserForm from '../../components/UserForm/UserForm';
import { CREATE_USER } from '../../constants';

function UserCreation() {
  return <UserForm type={CREATE_USER} />;
}

export default UserCreation;
